export const menus = [
    {
        title: 'AIH',
        path: '/governanceroom/dashboardsihsus/aih',
        gap: true
    },
    {
        title: 'Perfil',
        path: '/governanceroom/dashboardsihsus/perfil'
    },
    {
        title: 'UTI e UI',
        path: '/governanceroom/dashboardsihsus/uti'
    },
    {
        title: 'Internação',
        path: '/governanceroom/dashboardsihsus/hospitalization'
    },
    {
        title: 'Faturamento',
        path: '/governanceroom/dashboardsihsus/revenue'
    },
    {
        title: 'Procedimentos',
        path: '/governanceroom/dashboardsihsus/procedures'
    },
    {
        title: 'Altas',
        path: '/governanceroom/dashboardsihsus/discharge'
    }
];
